/* eslint-disable */
var baseApiUrl = ''
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'http://sensorapi.geodemosolutions.com/public/'
  baseApiUrl = 'https://sensorapi.geodemosolutions.com/public/'
}
else {
  // baseApiUrl = 'https://localhost/SensorAPI/public/'
  baseApiUrl = 'http://localhost/SensorAPI/public/'
}

export {
  baseApiUrl
}
